import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlineRounded";

/**
 * Deliberately free of router, MSAL and app context hooks: this also renders
 * when the crash happened above those providers, where such hooks would throw
 * a second time and produce a blank page.
 */
export const ErrorFallback = ({ error, onRetry }) => (
  <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
    <Stack spacing={2} sx={{ maxWidth: 640, width: "100%" }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <ErrorOutlineIcon color="error" />
        <Typography variant="h5">Something went wrong</Typography>
      </Stack>
      <Typography>
        This part of the portal failed to load. Trying again will usually fix
        it. If it keeps happening, please contact support.
      </Typography>
      {import.meta.env.DEV && error && (
        <Box
          component="pre"
          sx={{
            m: 0,
            p: 2,
            borderRadius: 1,
            bgcolor: "action.hover",
            fontSize: "0.75rem",
            overflow: "auto",
            maxHeight: 240,
            whiteSpace: "pre-wrap",
          }}
        >
          {error.stack || error.message || String(error)}
        </Box>
      )}
      <Stack direction="row" spacing={1}>
        {onRetry && (
          <Button variant="contained" onClick={onRetry}>
            Try again
          </Button>
        )}
        <Button variant="outlined" onClick={() => window.location.assign("/")}>
          Go to dashboard
        </Button>
      </Stack>
    </Stack>
  </Box>
);
